import {FICTION_SERIES} from "./schemas/FICTION_SERIES";
import {BetaReaderMatchUse, ProjectDescriptorType, ProjectDescriptorUse} from "./enums";

export type ProjectSchema = {
    sectionLayout: ProjectSchemaSectionLayout[],
    projectLevel: number
};

export type ProjectSchemaSectionLayout = {
    level: number,
    sectionName: string,
    toolbarSelectedName: string,
    toolbarDropDownLabel: string,
    toolbarIconHTML: string,
    tocIconHTML: string,
    latexCode: string,
    requiresName: boolean,
    hasContent: boolean,  // Some types - like series - won't have actual content. Those just exist in the TOC, not in section storage.
    metadataKeys: string[],
};

export type ProjectSchemaDisplay = {
    displayName: string,
    code: string,
    schema: ProjectSchema,
    initialContentHTML: string,
    initialContent: string,
    projectDescriptorCategories: ProjectDescriptorCategory[]
}

export type ProjectDescriptorCategory = {
    uniqueId: string, //Must be unique across all categories for this project schema
    betaReaderMatchUse: BetaReaderMatchUse,
    betaReaderMatchWeight: number | null, //How many points that a match impacts the project score - null if DO_NOT_USE_TO_MATCH or REJECT_ON_MATCH
    uses: ProjectDescriptorUse[],
    descriptors: ProjectDescriptor[],
    variants: ProjectDescriptorCategoryVariant[],
}

export type ProjectDescriptorCategoryVariant = {
    label: string,
    help: string | null,
    questionType: ProjectDescriptorType | null,
    tagIcon: string | null,
    tagColor: string | null,
    uses: ProjectDescriptorUse[]
}

export type ProjectDescriptor = {
    uniqueId: string, //Must be unique within the category
    label: string,
    help: string | null,
}

export class SCHEMA_CODE {
    FICTION_SERIES = FICTION_SERIES.code;
}

export class ProjectSchemas {

    static CODES: string[] = Object.values(SCHEMA_CODE);

    static SCHEMADISPLAY_BY_CODE: { [key: string]: ProjectSchemaDisplay } = {
        "FICTION_SERIES": FICTION_SERIES
    };

    static readonly DEFAULT_PROJECT_SCHEMA_DISPLAY: ProjectSchemaDisplay = this.SCHEMADISPLAY_BY_CODE.FICTION_SERIES;

    static getCategoryByUniqueId = (schemaCode: string, categoryId: string): ProjectDescriptorCategory => {
        return this.SCHEMADISPLAY_BY_CODE[schemaCode].projectDescriptorCategories.find(c => c.uniqueId === categoryId);
    }

    static getDescriptorByUniqueId = (schemaCode: string, categoryId: string, descriptorId: string): ProjectDescriptor => {
        return this.getCategoryByUniqueId(schemaCode, categoryId).descriptors.find(d => d.uniqueId === descriptorId);
    }

    static getVariantByCategoryAndUse = (category: ProjectDescriptorCategory, use: ProjectDescriptorUse): ProjectDescriptorCategoryVariant => {
        return category.variants.find(v => v.uses.includes(use));
    }
}
